// eslint-disable-next-line no-unused-vars
const { values } = require('lodash');
const types = require('../../../../../jsdoc-types');
const { default: getFrontConfig } = require('../../common/getFrontConfig');
const adyenPaymentMethods = require('../../../../../config/adyenPaymentMethods');
const { isEmpty } = require('../../common/utils/type');
const { objectify } = require('../../common/utils/objectUtils');

const FRONT_CONFIG = getFrontConfig();
const { paymentMethods } = FRONT_CONFIG.checkout;

/**
 * @typedef {types.SFCCCardType | adyenPaymentMethods.AdyenPaymentMethodName} AdyenComponentSelectedPM
 */

/** @type {Object.<AdyenComponentSelectedPM, string>} */
const adyenComponentPaymentMethodForAnalytics = {
  ...objectify(
    Object.values({
      ...types.SFCCCardTypes,
      ...adyenPaymentMethods.AdyenPaymentMethodNames,
    }),
  ),
  [types.SFCCCardTypes.Master]: 'Mastercard',
  [types.SFCCCardTypes.Mastercard]: 'Mastercard',
};

const otherPaymentMethodsForAnalytics = {
  [paymentMethods.ADYEN_PAYBYLINK]: 'AdyenPayByLink',
  [paymentMethods.ADYEN_POS]: 'AdyenPOS',
  [paymentMethods.APPLE_PAY]: 'Apple Pay',
  [paymentMethods.CashOnDelivery]: 'CashOnDelivery',
  [paymentMethods.Klarna]: 'Klarna',
  [paymentMethods.MERCADOPAGO]: 'MercadoPago',
  [paymentMethods.MERCADOPAGO_PAYBYLINK]: 'MercadoPagoPayByLink',
  [paymentMethods.PAYPAL]: 'PayPal',
  [paymentMethods.REDELCOM]: 'Redelcom',
  [paymentMethods.WAYFORPAY]: 'WayForPay',
};

/**
 * Return analytics display name for payment instrument
 * @param {types.PaymentInstrument} paymentInstrument method ID
 * @return {string} Payment method display name for Analytics
 */
function getPaymentTypeForAnalytics(paymentInstrument) {
  let paymentType;
  const paymentMethodId = paymentInstrument.paymentMethod;
  if (paymentMethodId === paymentMethods.AdyenComponent) {
    /** @type {AdyenComponentSelectedPM} */
    const { selectedAdyenPM } = paymentInstrument;
    paymentType = adyenComponentPaymentMethodForAnalytics[selectedAdyenPM]
      ?? selectedAdyenPM;
  } else if (paymentMethodId === paymentMethods.Klarna) {
    paymentType = paymentInstrument.paymentCategory;
  } else {
    paymentType = otherPaymentMethodsForAnalytics[paymentMethodId];
  }

  if (isEmpty(paymentType)) {
    paymentType = paymentMethodId;
  }

  return paymentType;
}

module.exports = {
  getPaymentTypeForAnalytics,
};
